import React from 'react';
import Footer from '../common/footer';
import Header from '../common/header';
import { ConnectedReduxProps} from '../../store';
import styles from '../custom/not-found.module.css';
import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import withParams from '../common/withParams';
import withRouter from '../common/withRouter';
import { Params } from 'react-router-dom';

type LocationState = {
  error?: string;
}
interface WithParamsProps {
  params: Params<string>;
}

type AllProps = ConnectedReduxProps & WithParamsProps & {
  router: {
    location: Location & { state: LocationState };
  };
};

class NotFound extends React.Component<AllProps> {

  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

public render() {
  const { router } = this.props;
  const HeaderWithParams = withParams(Header);

      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden'
        }}>
          <HeaderWithParams {...this.props} />
          <div className={styles.container}>
            <div className={styles.text}>{this.localization.get(router.location.state?.error || 'home.search.resourceNotFound')}</div><br/>
           </div>
          <Footer {...this.props} />
        </div>);
    }
  }
export default withRouter(NotFound);
